import { render, staticRenderFns } from "./MerrcoLanding.vue?vue&type=template&id=33dd1e2c&scoped=true&"
import script from "./MerrcoLanding.vue?vue&type=script&lang=js&"
export * from "./MerrcoLanding.vue?vue&type=script&lang=js&"
import style0 from "./MerrcoLanding.vue?vue&type=style&index=0&id=33dd1e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dd1e2c",
  null
  
)

export default component.exports